var _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedDropIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3334 14.0003C27.3334 21.088 21.5877 26.8337 14.5001 26.8337C7.41243 26.8337 1.66675 21.088 1.66675 14.0003C1.66675 6.91267 7.41243 1.16699 14.5001 1.16699C21.5877 1.16699 27.3334 6.91267 27.3334 14.0003ZM25.0001 14.0003C25.0001 19.7993 20.2991 24.5003 14.5001 24.5003C8.70109 24.5003 4.00008 19.7993 4.00008 14.0003C4.00008 8.20134 8.70109 3.50033 14.5001 3.50033C20.2991 3.50033 25.0001 8.20134 25.0001 14.0003Z",
    fill: ""
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14,
    r: 10.5,
    fill: "#D14545"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4999,
    cy: 13.9997,
    r: 4.66667,
    fill: "#F7FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDropIcon);
export default __webpack_public_path__ + "static/media/redDropIcon.f6658d2d426885687e404a897c1dffbe.svg";
export { ForwardRef as ReactComponent };